import * as React from "react";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";
import Textarea from "../../Textarea-new/Textarea";

const Website = ({ isAgent, data, handleChangeInput, viewMode, deleted }) => {
  return (
    <div className="Website">
      <div className="Website_actions">
        <Checkbox
          text="STRIVE Slider"
          type={viewMode ? "uncheckable" : "checkable"}
          isSelected={data.STRIVE_SLIDER}
          handleClick={handleChangeInput}
          name="STRIVE_SLIDER"
        />
        <Checkbox
          text="FEATURED"
          type={viewMode ? "uncheckable" : "checkable"}
          isSelected={data.FEATURED}
          handleClick={handleChangeInput}
          name="FEATURED"
        />
        <Checkbox
          text="VISIBLE"
          type={viewMode ? "uncheckable" : "checkable"}
          isSelected={data.VISIBLE}
          handleClick={handleChangeInput}
          name="VISIBLE"
        />
      </div>
      <div className="Website_column">
        <Input
          className="Website_column_item"
          type="text"
          valueType="text"
          name="MEDIA_KIT"
          label="Marketing Package"
          value={data.MEDIA_KIT}
          disabled={isAgent}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Website_column_item"
          type="text"
          valueType="text"
          name="PHOTOS"
          label="Photos"
          value={data.PHOTOS}
          disabled={isAgent}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Website_column_item"
          type="text"
          valueType="text"
          name="VIDEO_URL"
          label="VIDEO_URL"
          value={data.VIDEO_URL}
          disabled={isAgent}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Textarea
          className="Website_column_item"
          disabled={isAgent}
          label="Highlights"
          name="HIGHLIGHTS"
          value={data.HIGHLIGHTS}
          maxWidth="100%"
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default Website;
